// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shareLinkStyles } from "@conklin/Overrides/Widgets/ProductDetails/ProductDetailsShareLink";
import IconCopy from "@conklin/XDL/Icons/IconCopy";
import IconMail from "@conklin/XDL/Icons/IconMail";
import IconPrint from "@conklin/XDL/Icons/IconPrint";
import { color, createLinkIconStyles, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

shareLinkStyles.wrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 16px 24px;
        margin-top: 12px;
    `,
};
shareLinkStyles.link = { link: createLinkIconStyles(IconMail, "small") };
shareLinkStyles.printLink = createLinkIconStyles(IconPrint, "small");
shareLinkStyles.copyLink = createLinkIconStyles(IconCopy, "small");

shareLinkStyles.separator = {
    css: css`
        display: none;
        ${xScreen("lt", "sm")} {
            display: block;
            width: 100%;
            height: 1px;
            border-top: 1px solid ${color("common.border")};
            margin: 0;
        }
        @media print {
            display: none;
        }
    `,
};
